export const FORM_NAME = 'choose-public-funding-modal-form';
export const radioButtonName = 'type';

export const NUMERAL_FORMAT = '0.00';
export const NUMERAL_CURRENCY_FORMAT = `$${NUMERAL_FORMAT}`;

export const MIN_FUNDED_MINUTES_PER_DAY = 60;
export const MAX_FUNDED_MINUTES_PER_DAY = 1440;
